import { FormField } from '../../type';
import { generateInitialValues } from '../formBuilder';
import { prefillValues } from './prefillValues';
import useUrlQuery from './useUrlQuery';

interface Args {
  fields: FormField[];
}

/**
 * The empty form, with whatever the url prefills merged over it. Arrives after
 * mount, so the forms it feeds keep `enableReinitialize` on.
 */
const useInitialValues = ({ fields }: Args): Record<string, unknown> => {
  const query = useUrlQuery();

  return {
    ...generateInitialValues(fields),
    ...prefillValues({ fields, query }),
  };
};

export default useInitialValues;
